import menu from "../common/data/sideMenu"

/**
 * Get menu item information by exact route path match
 * Only for listing pages - requires exact URL match
 * @param {string} path - The current route path
 * @returns {object} Object containing name, menuGroup, titleLink, and formatted breadcrumb
 */
export const getMenuInfoByPath = path => {
  // Find the menu item that exactly matches the path
  const menuItem = menu.find(item => item.href === path)

  if (!menuItem) {
    return {
      name: "",
      menuGroup: null,
      breadcrumbTitle: "",
      pageHeading: "",
      titleLink: "",
    }
  }

  // Format the page heading: "Menu Group - Menu Name" or just "Menu Name"
  const pageHeading = menuItem.menuGroup
    ? `${menuItem.menuGroup} - ${menuItem.name}`
    : menuItem.name

  return {
    name: menuItem.name,
    menuGroup: menuItem.menuGroup,
    breadcrumbTitle: menuItem.menuGroup || menuItem.name,
    pageHeading: pageHeading,
    titleLink: menuItem.href || "",
  }
}

/**
 * Get breadcrumb title (menuGroup if exists, otherwise menu name)
 * @param {string} path - The current route path
 * @returns {string} The breadcrumb title
 */
export const getBreadcrumbTitle = path => {
  const menuInfo = getMenuInfoByPath(path)
  return menuInfo.breadcrumbTitle
}

/**
 * Get page heading (formatted as "Menu Group - Menu Name" if menuGroup exists)
 * @param {string} path - The current route path
 * @returns {string} The formatted page heading
 */
export const getPageHeading = path => {
  const menuInfo = getMenuInfoByPath(path)
  return menuInfo.pageHeading
}
